import { h ,FunctionalComponent} from 'preact';
import { useEffect, useState } from 'preact/hooks';
import * as XLSX from 'xlsx';

interface Props {
    url: string;
    rowNumber: string;
    sheet: string;
    
  }
  
  

const DataRowDisplay:FunctionalComponent<Props> = (props: Props) => {
    const {
      url,
      rowNumber,
      sheet,
    } = props;
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const arrayBuffer = await response.arrayBuffer();
            const workbook = XLSX.read(arrayBuffer, { type: 'buffer' });
            
            // Assuming the first worksheet here
            // console.log(sheet);
            const worksheet = workbook.Sheets[sheet];
            const json = XLSX.utils.sheet_to_json(worksheet);
            //need to check if the header is in the first line.
            if(rowNumber ==="1")
            {
                setRowData(json[Number(rowNumber)-1] as any);
            }
            else{
                setRowData(json[Number(rowNumber)-2] as any);
            }
            
            } catch (e:any) {
                setError(e.message);
                setLoading(false);
            }
        };

        fetchData();
    }, [url, rowNumber]);


const rowContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: '#f9f9f9', 
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    borderRadius: '8px', 
    overflow: 'hidden', 
    fontFamily: '"Segoe UI", Roboto, sans-serif', // Font similar to the one in the image
    fontSize: '16px', // Base font size
    lineHeight: '1.6', // Line height for better readability
};

const rowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center', 
    borderBottom: '1px solid #ddd', 
    padding: '15px 20px', 
    backgroundColor: '#fff', 

};

const headerStyle = {
    fontWeight: '600',
    color: '#555', 
    flex: '0 0 150px', 
    paddingRight: '20px', 
};

const valueStyle = {
    color: '#333', // Darker text for value
    textAlign: 'left', // Align value to the right
    flex: '1', // Take up the remaining space
};

return (
    <div>
        <div style={rowContainerStyle}>
            {rowData && Object.entries(rowData).map(([header, value], index) => (
                <div key={index} style={rowStyle}>
                    <div style={headerStyle}>{header}</div>
                    <div style={valueStyle}>{value}</div>
                </div>
            ))}
        </div>
    </div>
);
};


export default DataRowDisplay;